import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api/api.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.page.html',
  styleUrls: ['./privacy-policy.page.scss'],
})
export class PrivacyPolicyPage implements OnInit {
  result:any= ''
  constructor(public api: ApiService) { }

  ngOnInit() {
    this.api.getPrivacyPolicy().subscribe((result:any) => {
      this.result = result.data
      console.log(result)
    })
  }

}
